/**
 * Helper centralizado para matrículas de servidor (modelo matriculas_servidor).
 */
export class MatriculaServidorHelper {

  static getMatriculas(servidor: any, idCidade?: number): any[] {
    if (!servidor) return [];
    if (servidor.matriculas && servidor.matriculas.length) {
      if (idCidade) {
        return servidor.matriculas.filter((m: any) => m.id_cidade == idCidade);
      }
      return servidor.matriculas;
    }
    return [];
  }

  static getMatriculaAtiva(servidor: any, idCidade?: number, idMatricula?: number): any {
    const lista = MatriculaServidorHelper.getMatriculas(servidor, idCidade);
    if (idMatricula != null) {
      const selecionada = lista.find((matricula: any) => matricula.id == idMatricula);
      if (selecionada) return selecionada;
    }
    if (lista.length) return lista[0];
    return null;
  }

  static getMatriculaDisplay(servidor: any): string {
    if (!servidor) return '';
    const ativa = MatriculaServidorHelper.getMatriculaAtiva(
      servidor,
      servidor.id_cidade,
      servidor.id_matricula
    );
    if (ativa && ativa.matricula) return ativa.matricula;
    return '';
  }

  static getStatus(servidor: any, idCidade?: number): number {
    const ativa = MatriculaServidorHelper.getMatriculaAtiva(
      servidor,
      idCidade,
      servidor && servidor.id_matricula
    );
    if (ativa && ativa.status != null) return ativa.status;
    return null;
  }

  static getOrgao(servidor: any, idCidade?: number): any {
    const ativa = MatriculaServidorHelper.getMatriculaAtiva(
      servidor,
      idCidade,
      servidor && servidor.id_matricula
    );
    if (ativa && ativa.orgao != null) return ativa.orgao;
    return null;
  }

  static getAtendimento(servidor: any, idCidade?: number): { inicio_atendimento?: any; fim_atendimento?: any } {
    const ativa = MatriculaServidorHelper.getMatriculaAtiva(
      servidor,
      idCidade,
      servidor && servidor.id_matricula
    );
    if (ativa && ativa.atendimento) return ativa.atendimento;
    if (ativa && (ativa.inicio_atendimento || ativa.fim_atendimento)) {
      return { inicio_atendimento: ativa.inicio_atendimento, fim_atendimento: ativa.fim_atendimento };
    }
    return {};
  }

  static temMultiplasMatriculas(servidor: any, idCidade?: number): boolean {
    const lista = MatriculaServidorHelper.getMatriculas(servidor, idCidade);
    return lista.length > 1;
  }

  /** Aplica campos flat de compatibilidade a partir da matrícula ativa. */
  static normalizarServidor(servidor: any, idCidade?: number, idMatricula?: number): any {
    if (!servidor) return servidor;
    const cid = idCidade || servidor.id_cidade;
    const ativa = MatriculaServidorHelper.getMatriculaAtiva(servidor, cid, idMatricula);
    if (!ativa) return servidor;

    servidor.matriculas = MatriculaServidorHelper.getMatriculas(servidor, cid);
    servidor.id_matricula = ativa.id;
    servidor.matricula = ativa.matricula;
    servidor.status = ativa.status;
    servidor.id_cidade = ativa.id_cidade || servidor.id_cidade;
    servidor.orgao = ativa.orgao;
    servidor.administracao = ativa.administracao || servidor.administracao;

    const atend = MatriculaServidorHelper.getAtendimento(servidor, cid);
    servidor.inicio_atendimento = atend.inicio_atendimento;
    servidor.fim_atendimento = atend.fim_atendimento;

    // A matrícula selecionada identifica o beneficiário nos dois benefícios.
    // matricula_pensao é um dado diferente: a matrícula do instituidor da pensão.
    if (ativa.status == 2 || ativa.status == 3) {
      servidor.matricula_beneficiario = ativa.matricula;
    }
    servidor.duasmatriculas = MatriculaServidorHelper.temMultiplasMatriculas(servidor, cid);
    return servidor;
  }

  static normalizarLista(servidores: any[], idCidade?: number): any[] {
    return (servidores || []).map(s => MatriculaServidorHelper.normalizarServidor(s, idCidade));
  }
}
